import React,{useState,useEffect,useRef}from 'react'
import { Modal,App,Form, Radio, Rate} from 'antd';
import dayjs from 'dayjs'
import { useRenwuUpdateQuery, useRenwuUpdateSaveMutation } from '../store/BnsKeJiApi';
import MyEditor from '../cpn/MyEditor';
import {EyeOutlined,} from '@ant-design/icons';
function TaskCheck(props) {    
    const {message} = App.useApp()
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        rw_id:props.rw_id,
        rw_pj_content:'',
        rw_pj_tate:"",
    }); 
    const {data,isSuccess} = useRenwuUpdateQuery({rw_id:props.rw_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    rw_name:data.Result.rw_name,
                    rw_dept_id:data.Result.rw_dept_id,
                    rw_content:data.Result.rw_content,
                    rw_js_uname:data.Result.rw_js_uname,
                    rw_end_date:dayjs(data.Result.rw_end_date),
                    rw_js_content:data.Result.rw_js_content,
                    rw_state:data.Result.rw_state,
                    rw_pj_tate:data.Result.rw_pj_tate,
                    rw_pj_content:data.Result.rw_pj_content,
                })
                setInfo(prevState=>({...prevState,
                    rw_content:data.Result.rw_content,
                    rw_dept_id:data.Result.rw_dept_id,
                    rw_e_id:data.Result.rw_e_id,
                    rw_end_date:data.Result.rw_end_date,
                    rw_fb_uid:data.Result.rw_fb_uid,
                    rw_fb_uname:data.Result.rw_fb_uname,
                    rw_js_uid:data.Result.rw_js_uid,
                    rw_js_uname:data.Result.rw_js_uname,
                    rw_name:data.Result.rw_name,
                    rw_state:data.Result.rw_state,
                    rw_uid:data.Result.rw_uid,
                    rw_uname:data.Result.rw_uname,               
                    rw_js_content:data.Result.rw_js_content,               
                    rw_pj_content:data.Result.rw_pj_content,               
                    rw_js_update_time:data.Result.rw_js_update_time,               
                    rw_pj_tate:data.Result.rw_pj_tate,               
                    rw_pj_update_time:data.Result.rw_pj_update_time,               
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useRenwuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EyeOutlined /> 查看</a>
            <Modal
                width={1200}                        
                open={open}
                title='团队任务'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        rw_id:props.rw_id,
                        rw_content:info.rw_content,
                        rw_dept_id:info.rw_dept_id,
                        rw_e_id:info.rw_e_id,
                        rw_end_date:info.rw_end_date,
                        rw_fb_uid:info.rw_fb_uid,
                        rw_fb_uname:info.rw_fb_uname,
                        rw_js_uid:info.rw_js_uid,
                        rw_js_uname:info.rw_js_uname,
                        rw_name:info.rw_name,
                        rw_state:info.rw_state,
                        rw_uid:info.rw_uid,
                        rw_uname:info.rw_uname,               
                        rw_js_content:info.rw_js_content,               
                        rw_pj_content:info.rw_pj_content,               
                        rw_js_update_time:props.eu_id === +info.rw_js_uid ? dayjs().format('YYYY-MM-DD HH:mm:ss'):info.rw_js_update_time,               
                        rw_pj_tate:info.rw_pj_tate,               
                        rw_pj_update_time:props.eu_id === +info.rw_uid ? dayjs().format('YYYY-MM-DD HH:mm:ss'):info.rw_pj_update_time, 
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.rw_id}`} 
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                    ref={editForm}
                >                    
                    <Form.Item
                        label='标题' 
                        style={{marginBottom:"0"}}                       
                    >
                        {info.rw_name}
                    </Form.Item>
                    <Form.Item
                        label='任务说明'
                        style={{marginBottom:"0"}}   
                    >
                       <div dangerouslySetInnerHTML={{__html:info.rw_content}} style={{paddingTop:"5px"}}></div>
                    </Form.Item>
                    <Form.Item
                        label='验收说明'
                        name='rw_js_content'
                    >
                        {(info.rw_state !=='3' && props.eu_id=== +info.rw_js_uid) ?<MyEditor 
                                                                                    height='300px'
                                                                                    width='800px'
                                                                                    onChange={(e) => {setInfo(prev => ({...prev,rw_js_content:e}))}}
                                                                                /> : <div dangerouslySetInnerHTML={{__html:info.rw_js_content}} style={{paddingTop:"5px"}}></div>}
                    </Form.Item>  
                    <Form.Item
                        label='评分'
                        name='rw_pj_tate'
                    >
                        <Rate 
                            onChange={(e) => {setInfo(prev => ({...prev,rw_pj_tate:e}))}}
                            disabled={(props.eu_id !== +info.rw_uid) || (props.eu_id === +info.rw_uid && info.rw_state === '1')}
                        />
                    </Form.Item>             
                   <Form.Item
                        label='评价说明'
                        name='rw_pj_content'
                    >
                        {((props.eu_id=== +info.rw_uid) && (info.rw_state ==='2'||info.rw_state==='3')) ?<MyEditor 
                            height='300px'
                            width='800px'
                            onChange={(e) => {setInfo(prev => ({...prev,rw_pj_content:e}))}}
                        />:<div dangerouslySetInnerHTML={{__html:info.rw_pj_content}} style={{paddingTop:"5px"}}></div>}
                    </Form.Item>
                                
                    <Form.Item
                        label='修改状态'
                        name='rw_state'
                    >
                        <Radio.Group                            
                            onChange={(e) => {setInfo(prev => ({...prev,rw_state:e.target.value}))}}
                            disabled={(props.eu_id=== +info.rw_js_uid && info.rw_state==='3') || (props.eu_id !== +info.rw_js_uid && props.eu_id !== +info.rw_uid) || (props.eu_id=== +info.rw_uid && info.rw_state === '1')}
                        >
                            <Radio value='1'>待验收</Radio>
                            <Radio value='2'>待评价</Radio>
                            <Radio value='3' disabled={(props.eu_id=== +info.rw_js_uid && info.rw_state==='3') || (props.eu_id !== +info.rw_js_uid && props.eu_id !== +info.rw_uid) || (props.eu_id=== +info.rw_js_uid) || (props.eu_id=== +info.rw_uid && info.rw_state === '1')} >已结束</Radio>
                        </Radio.Group>
                    </Form.Item>               
                </Form>
            </Modal>
        </>
    )
}

export default TaskCheck